export default (tab,steps,stepperState)=>{
	let editable = true 
	if (steps !== undefined && tab !== undefined) {
		const stepsId = steps.findIndex(x => x.key === stepperState)
		if (stepsId > -1) {
			editable = tab.find((x) => x.section === steps[stepsId].apiId).editable
		}
	}

	if (editable === undefined) editable = true

	return editable
}